<div class='container'>
  <!-- section title -->
  <h2 class='section-title wow fadeInUp'>{{ 'nav.programs' | translate | titlecase }}</h2>

  <div class='spacer-60'></div>

  <div class='row'>
    <div class='col-md-4'>
      <!-- service box -->
      <div class='service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow'>
        <img class='w-50' src='assets/images/service-2.svg' alt='JavaScript Course' />
        <h3 class='mb-3 mt-0'>{{ 'sections.programs.javaScriptBeginner.titleCourse' | translate }}!</h3>
        <p class='mb-0'>{{ 'sections.programs.javaScriptBeginner.paragraph' | translate }}!</p>
        <div class='mt-4'>
          <kdn-button
            (kdmClick)="scrollTo('curriculum', 'javascript')"
            [label]="'buttons.viewProgram' | translate">
          </kdn-button>
        </div>
      </div>
      <div class='spacer-30 d-md-none d-lg-none'>
      </div>
    </div>

        <div class='col-md-4'>
          <!-- service box -->
          <div class='service-box rounded data-background padding-30 text-center text-light shadow-blue bg-blue'>
            <img src='assets/images/service-1.svg' alt='UI/UX design' />
            <h3 class='mb-3 mt-0'>{{ 'sections.programs.uxDesign.titleCourse' | translate }}</h3>
            <p class='mb-0'>{{ 'sections.programs.uxDesign.paragraph' | translate }}.</p>
            <div class='mt-4'>
              <kdn-button
                (kdmClick)="scrollTo('curriculum', 'ux-design')"
                [label]="'buttons.viewProgram' | translate">
              </kdn-button>
            </div>
          </div>
          <div class='spacer-60 d-md-none d-lg-none'></div>
        </div>

    <div class='col-md-4'>
      <!-- service box -->
      <div class='service-box rounded data-background padding-30 text-center text-light shadow-pink bg-pink'>
        <img src='assets/images/service-3.svg' alt='UI/UX design' />
        <h3 class='mb-3 mt-0'>{{ 'sections.programs.angularBeginner.titleCourse' | translate }}!</h3>
        <p class='mb-0'>{{ 'sections.programs.angularBeginner.paragraph' | translate }}.</p>
        <div class='mt-4'>
          <kdn-button
            (kdmClick)="scrollTo('curriculum', 'angularjs')"
            [label]="'buttons.viewProgram' | translate">
          </kdn-button>
        </div>
      </div>
    </div>

  </div>

  <!--  <div class="mt-5 text-center">-->
  <!--    <p class="mb-0">Looking for a custom job? <a href="javascript:" (click)="scrollTo('contact')">Click here</a> to contact me! 👋</p>-->
  <!--  </div>-->
</div>
